<nav class="admin-nav-tabs">
  @for (tab of tabs; track tab) {
    <button
      [class.active]="activeTab === tab.value"
      (click)="selectTab(tab.value)">
      <mat-icon>{{ tab.icon }}</mat-icon>
      <span>{{ tab.label }}</span>
    </button>
  }
</nav>
